exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dice .status[data-v-6ab1eabc]{text-align:center\n}\n.dice .status .action[data-v-6ab1eabc]{color:#2c2824\n}\n", ""]);

// exports
